<template lang="html">
	<div :class="sendFormTime ? 'form-submit load' : 'form-submit'">
		<button @click='click' >
			<slot>Button name</slot>
		</button>
	</div>
</template>

<script>
module.exports = {
	name: 'submit',



	data() {
		return {
			validFlagsArray: [],
			validFlags: [],
			complete: true,
			identic: true,
			sendFormTime: false
		}
	},

	methods: {
		click(e) {
			this.validFlagsArray = [];
			this.complete = true;

			let payload = {};
			// this.$parent.$refs - це всі інпути, які внесені в refs батьківського компонента (форми)
			// console.log(this.validFlagsArray)
			// console.log(this.$parent.$refs)

			for (var component in this.$parent.$refs) {
				if (this.$parent.$refs.hasOwnProperty(component) && this.$parent.$refs[component].length) {
					try {
						this.$parent.$refs[component][0].validate();
						this.validFlags[component] = this.$parent.$refs[component][0].valid;
					}
					catch (err){
						console.log(err);
					}
					this.validFlagsArray.push([
						this.$parent.$refs[component][0].valid,
						this.$parent.$refs[component][0].$el.querySelector('input')
					]);
					// console.log(this.$parent.$refs[component][0].name);
					if(this.$parent.$refs[component][0].name){
						payload[this.$parent.$refs[component][0].name] = this.$parent.$refs[component][0].inputValue;
					}
				}
			}

			// console.log(this.validFlagsArray);

			for(var i = 0; i < this.validFlagsArray.length; i++) {
				if(!this.validFlagsArray[i][0]) {
					this.complete = false;
					break;
				}
			}

			let t = setTimeout(() => {
				for (var component in this.$parent.$refs) {
					let str = this.$parent.$refs[component][0].$el.attributes.class.value;
					if(str.indexOf('incomplete')){
						// console.log(this.$parent.$refs[component][0].$el.attributes.class.value);
						// this.complete = false;
					}
				}
			}, 300);


			// var el = document.querySelectorAll('.incomplete');
			// var _this = this;
			setTimeout(() => {
				var k = e.target.closest('.VueForm').classList[1];
				var el = document.querySelectorAll('.'+ k + ' .incompleted');

				for(var i = 0; i < this.validFlagsArray.length; i++) {

					if(this.complete) {
						// console.log(el.length);
						// console.log(el);
						if(el.length == 0){
							// console.log('COMPLETE');
							this.$emit('COMPLETE', payload);
							this.sendFormTime = true
						}else {
							this.$emit('INCOMPLETE', this.validFlagsArray[i][1]);
						}
					}
					else {
						// alert('INCOMPLETE');
						this.$emit('INCOMPLETE', this.validFlagsArray[i][1]);
					}
				}
			}, 0)
		}
	}
}
</script>

<style lang="scss">
	.form-submit{
		position: relative;
		&.load{
			&:before{
				position: absolute;
				left: 10px;
				// background-image: url('#{$imgPathSCSS}orbit.gif');
				background-image: url('../img/spinning-circles.svg');
				top: calc(50% - 10px);
				width: 20px;
				height: 20px;
				content: "";
				background-size: cover;
			}
		}
		button{
		height: 50px;
		border-radius: 25px;
		background-color: #2967a7;
		border: 1px solid #2967a7;
		color: #ffffff;
		box-shadow: 0px 28px 37.6px 2.4px rgba(170, 188, 200, 0.24),0px 11px 51.94px 1.06px rgba(170, 188, 200, 0.16);
		transition: all .5s ease-out 0s;
		text-transform: uppercase;
		text-decoration: none;
		font-weight: 600;
		font-size: 14px;
		&:hover, &:active, &:focus, {
			background-color: #387fc8;
			border-color: #387fc8;
		}
	}
	}


</style>



// WEBPACK FOOTER //
// submit.vue?285b8224